/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_1_TitleInputs */

const en_terms_section_1_title = /** @type {(inputs: Terms_Section_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Acceptance of Terms`)
};

const lv_terms_section_1_title = /** @type {(inputs: Terms_Section_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Noteikumu pieņemšana`)
};

/**
* | output |
* | --- |
* | "1. Acceptance of Terms" |
*
* @param {Terms_Section_1_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_1_title = /** @type {((inputs?: Terms_Section_1_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_1_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_1_title(inputs)
	return en_terms_section_1_title(inputs)
});